import React from 'react';
import PropTypes from 'prop-types';
import ReportBox from '../../components/ReportBox';
import Num from '../../../../common/Num';
import Money from '../../../../common/money';
import haircut from '../../../../../../images/haircut.svg';

const ServicesSold = ({ servicesSold, averageServiceSale }) => (
  <ReportBox title="Services sold" automationId="container:servicesSold">
    <div className="u-text-center">
      <div className="c-report-stat c-report-stat--huge u-mv">
        <Num automationId="text:servicesSold:Amount">{servicesSold}</Num>
        <img className="u-vertical-align-8px u-ml" src={haircut} alt="" />
      </div>
      <div className="c-horizontal-divider" />
      <div className="c-report-label u-type--uppercase u-pt+ u-pb-">Avg.service sale</div>
      <div className="c-report-stat u-mb+">
        <Money automationId="text:servicesSold:AverageSale">{averageServiceSale}</Money>
      </div>
    </div>
  </ReportBox>
);
ServicesSold.propTypes = {
  servicesSold: PropTypes.number,
  averageServiceSale: PropTypes.number,
};
ServicesSold.defaultProps = {
  servicesSold: 0,
  averageServiceSale: 0,
};

export default ServicesSold;
